module.exports = __webpack_public_path__ + "static/media/data-ops.35fee590.svg";